import React from 'react';

const PAGES = [
  { key: 'home', label: 'Home', path: '/' },
  { key: 'shop', label: 'Shop', path: '/shop' },
  { key: 'contact', label: 'Contact', path: '/contact' },
  { key: 'about', label: 'About', path: '/about' },
];

function SeoPageCard({ page, form, setField }) {
  const prefix = `seo_${page.key}`;
  return (
    <div className="card border shadow-sm mb-3">
      <div className="card-header py-2">
        <h2 className="h6 mb-0">{page.label} page SEO</h2>
      </div>
      <div className="card-body row g-3">
        <div className="col-12">
          <label className="form-label" htmlFor={`${prefix}-title`}>
            Browser title
          </label>
          <input
            id={`${prefix}-title`}
            className="form-control"
            value={form[`${prefix}_title`] || ''}
            onChange={(e) => setField(`${prefix}_title`, e.target.value)}
          />
        </div>
        <div className="col-12">
          <label className="form-label" htmlFor={`${prefix}-desc`}>
            Meta description
          </label>
          <textarea
            id={`${prefix}-desc`}
            className="form-control"
            rows={2}
            value={form[`${prefix}_description`] || ''}
            onChange={(e) => setField(`${prefix}_description`, e.target.value)}
          />
        </div>
        <div className="col-12">
          <label className="form-label" htmlFor={`${prefix}-og`}>
            Open Graph image URL <span className="text-muted">(optional)</span>
          </label>
          <input
            id={`${prefix}-og`}
            type="url"
            className="form-control"
            placeholder="https://salonidesigns.com/…"
            value={form[`${prefix}_og_image`] || ''}
            onChange={(e) => setField(`${prefix}_og_image`, e.target.value)}
          />
          <div className="form-text">
            Used when this page is shared on social media. Canonical: salonidesigns.com{page.path}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function AdminSiteSeoFields({ form, setField }) {
  return (
    <>
      <p className="small text-muted mb-3">
        Titles and descriptions for search engines and social sharing.
      </p>
      {PAGES.map((page) => (
        <SeoPageCard key={page.key} page={page} form={form} setField={setField} />
      ))}
    </>
  );
}
